"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userPasswordValidators = exports.userPasswordSchema = void 0;
const zod_1 = require("zod");
const oneLowerCaseCharacter = zod_1.z
    .string()
    .regex(/[a-z]/, "one lowercase character is required");
const oneUpperCaseCharacter = zod_1.z
    .string()
    .regex(/[A-Z]/, "one uppercase character is required");
const eightCharactersMinimum = zod_1.z
    .string()
    .min(8, "at least 8 characters are required");
const oneNumber = zod_1.z.string().regex(/[0-9]/, "one number is required");
const oneSpecialCharacter = zod_1.z
    .string()
    .regex(/(?=.*\W)/, "one special character is required");
const userPasswordValidators = {
    oneLowerCaseCharacter,
    oneUpperCaseCharacter,
    eightCharactersMinimum,
    oneNumber,
    oneSpecialCharacter
};
exports.userPasswordValidators = userPasswordValidators;
const userPasswordSchema = oneLowerCaseCharacter
    .and(oneUpperCaseCharacter)
    .and(eightCharactersMinimum)
    .and(oneNumber)
    .and(oneSpecialCharacter);
exports.userPasswordSchema = userPasswordSchema;
